(() => {
  const initSection = (section) => {
    if (!section?.classList.contains('nb-ns-sitting-problem-section')) return;

    const counters = section.querySelectorAll('[data-count-target]');
    if (!counters.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animateCounter = (el) => {
      const target = parseInt(el.dataset.countTarget, 10);
      const suffix = el.dataset.countSuffix || '';
      const numEl = el.querySelector('.nb-sp__stat-num');
      if (!numEl || isNaN(target)) return;

      if (prefersReducedMotion) {
        numEl.textContent = target;
        return;
      }

      const duration = 1200;
      const start = performance.now();

      numEl.textContent = '0';

      const tick = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        numEl.textContent = Math.round(eased * target);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          numEl.textContent = target;
        }
      };

      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          counters.forEach(animateCounter);
          observer.disconnect();
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', (e) => initSection(e.target));
})();
